import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { User, Baby, Users, HeartHandshake, ArrowLeft } from 'lucide-react';
export function UserTypeScreen() {
  const navigate = useNavigate();
  const options = [{
    id: 'myself',
    title: 'Myself',
    desc: 'Book care for your own health needs',
    icon: User
  }, {
    id: 'child',
    title: 'My Child',
    desc: 'Pediatric care and vaccinations',
    icon: Baby
  }, {
    id: 'parent',
    title: 'My Parent',
    desc: 'Elderly care and chronic management',
    icon: Users
  }, {
    id: 'other',
    title: 'Someone Else',
    desc: 'Spouse, relative, or dependent',
    icon: HeartHandshake
  }];
  return <div className="min-h-screen bg-ui-bg flex flex-col" data-id="element-1732">
      <div className="pt-12 px-6 pb-4" data-id="element-1733">
        <button onClick={() => navigate(-1)} className="mb-6 p-2 -ml-2 rounded-full hover:bg-ui-card active:bg-ui-border transition-colors" data-id="element-1734">
          <ArrowLeft size={24} className="text-text-main" data-id="element-1735" />
        </button>
        <h1 className="text-3xl font-bold text-text-main mb-2" data-id="element-1736">
          Who needs care?
        </h1>
        <p className="text-text-secondary" data-id="element-1737">
          Select who you are booking for today. You can always add more family
          members later.
        </p>
      </div>

      <div className="px-6 flex-1 space-y-4 mt-4" data-id="element-1738">
        {options.map((option, idx) => <motion.button key={option.id} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: idx * 0.1
      }} onClick={() => navigate('/location-setup')} className="w-full flex items-center p-4 bg-white border border-ui-border rounded-2xl shadow-sm active:bg-ui-card active:scale-[0.98] transition-all text-left" data-id="element-1739">
            <div className="w-12 h-12 bg-brand-light rounded-full flex items-center justify-center mr-4 shrink-0" data-id="element-1740">
              <option.icon size={24} className="text-brand-primary" data-id="element-1741" />
            </div>
            <div data-id="element-1742">
              <h3 className="text-lg font-semibold text-text-main" data-id="element-1743">
                {option.title}
              </h3>
              <p className="text-sm text-text-secondary" data-id="element-1744">{option.desc}</p>
            </div>
          </motion.button>)}
      </div>
    </div>;
}